import React from "react";
import T from "prop-types";
import { translateProps } from "MODULES/shared/decorators";
import { Icon } from "MODULES/shared/components";
import ExternalLink from "MODULES/shared/components/ExternalLink/ExternalLink";
import { API_BASE, ID } from "APP_ROOT/constants";

export function Download({ url }) {
  return (
    <li>
      <ExternalLink url={url}>
        <Icon name="file-text-o" fixed />
        &nbsp;Download OQ
      </ExternalLink>
    </li>
  );
}

Download.propTypes = {
  url: T.string.isRequired
};

const withUrl = translateProps(({ outgoingQuote }) => ({
  url: `${API_BASE}/outgoing_quotes/${outgoingQuote.get(ID)}/download`
}));

export default withUrl(Download);



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/Detail/Download/Download.jsx